import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/privacy.scss";

function CookiePolicy() {
  return (
    <div className="privacy">
      <Header />
      <main>
        <div className="inner-pg">
          <div className="content">
            <h1>Cookie Policy</h1>
            <p>Last updated: September 8, 2026</p>
            <p>
              This policy explains how shiskerstone uses cookies and similar
              browser technologies when you visit our website.
            </p>
            <strong>Essential cookies</strong>
            <p>
              These support core functions such as navigation, cart contents,
              checkout security, and remembering choices during a session. The
              website may not work correctly without them.
            </p>
            <strong>Preference and analytics cookies</strong>
            <p>
              Where enabled, preference cookies remember settings and analytics
              cookies help us understand aggregate website use. We do not use
              this information to sell personal data.
            </p>
            <strong>Third-party services</strong>
            <p>
              Payment, delivery, font, or other service providers may set their
              own cookies when their features are used. Their handling of data
              is governed by their own notices.
            </p>
            <strong>Your choices</strong>
            <p>
              You can block or delete cookies in your browser settings. Blocking
              essential cookies may prevent the cart or checkout from working.
              Where a consent control is presented, you can update optional
              cookie choices through that control.
            </p>
            <strong>Contact</strong>
            <p>
              Questions about cookies may be sent to <u>print@shiskerstone.xyz</u>.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default CookiePolicy;
